// @ts-nocheck

export const isTimestampToday = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();

  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isTimestampTomorrow = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();
  const tomorrow = new Date(today);

  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    date.getDate() === tomorrow.getDate() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getFullYear() === tomorrow.getFullYear()
  );
};

export const isTimestampSameYear = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();

  return date.getFullYear() === today.getFullYear();
};

export const isTimestampLessThanOneWeek = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();
  const nextWeek = new Date(today);

  nextWeek.setDate(nextWeek.getDate() + 7);
  nextWeek.setHours(0, 0, 0, 0);

  return date.getTime() < nextWeek.getTime();
};

export const isOneWeekFromNow = (date) => {
  const oneWeekSecs = 6 * 24 * 60 * 60;
  return date ? Math.abs(date - Date.now() / 1000) > oneWeekSecs : false;
};

// =============================================================================
// Return the minute (int) of an event based on matchTime, stoppageTime
// matchTime format: '0:00'
// stoppageTime format: '0:00'
//
// Ex :
//  - 12:18 -> 13
//  - 45:00, 00:18 -> 45
//  - 45:00 -> 46
export const getMinuteFromMatchTime = (matchTime?: string, stoppageTime?: boolean) => {
  // if we are in stoppage time, we keep minute to previous minute else of matchTime, else we keep minute of matchTime + 1
  if (typeof matchTime !== 'string') {
    return null;
  }
  const [minute] = matchTime.split(':');
  if (!stoppageTime) {
    return parseInt(minute, 10) + 1;
  }
  return parseInt(minute, 10);
};

// =============================================================================
// Return the minute (string) of an event based on matchTime, stoppageTime
// matchTime format: '0:00'
// stoppageTime format: '0:00'
//
// Ex :
//  - 12:18 -> 13'
//  - 45:00, 00:18 -> 45'+1
//  - 45:00 -> 46'
export const getExtendedMinuteStringFromMatchTime = (matchTime, stoppageTime) => {
  if (typeof matchTime !== 'string') {
    return null;
  }
  const minute = getMinuteFromMatchTime(matchTime, stoppageTime);
  let stoppagePart = '';
  if (stoppageTime) {
    const [stoppageMinutes] = stoppageTime.split(':');
    const stoppageMinute = parseInt(stoppageMinutes, 10) + 1;
    stoppagePart = `+${stoppageMinute}`;
  } else {
    stoppagePart = '';
  }
  return `${minute}'${stoppagePart}`;
};

export const getTimerFromMatchTimeExtended = (matchTimeExtended: string, stoppageTime?: string) => {
  if (stoppageTime) {
    const [matchtimeMins, matchtimeSecs] = matchTimeExtended
      .split(':')
      .reduce((acc, k) => (k ? [...acc, parseInt(k, 10)] : acc), []);
    const [stoppageTimeMins, stoppageTimeSecs] = stoppageTime
      .split(':')
      .reduce((acc, k) => (k ? [...acc, parseInt(k, 10)] : acc), []);

    if (
      typeof matchtimeMins === 'number' &&
      typeof matchtimeSecs === 'number' &&
      typeof stoppageTimeMins === 'number' &&
      typeof stoppageTimeSecs === 'number'
    ) {
      const totalSecs = (matchtimeMins + stoppageTimeMins) * 60 + matchtimeSecs + stoppageTimeSecs;
      const mins = Math.floor(totalSecs / 60);
      const secs = totalSecs % 60;
      const minsAsStr = `${mins}`.padStart(2, '0');
      const secsAsStr = `${secs}`.padStart(2, '0');

      return `${minsAsStr}:${secsAsStr}`;
    }
  }

  return matchTimeExtended;
};
